export class VehicleModelDto {

  public id!: string;
  public name!: string;
  public manufacturerId!: string;

  constructor(init?: Partial<VehicleModelDto> | undefined) {
    Object.assign(this, init);
  }
}
